module.exports = __webpack_public_path__ + "img/backbuttonPressed.1072b808.png";